import { render } from "./PermissionItem.vue?vue&type=template&id=3a801c34&lang=pug"
import script from "./PermissionItem.vue?vue&type=script&lang=js"
export * from "./PermissionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__